
/**
 * Get the appropriate Tailwind CSS color classes for a category
 * @param category The category name
 * @returns Tailwind CSS classes for the category
 */
export const getCategoryColor = (category: string) => {
  switch (category) {
    case "Yoga":
      return "bg-blue-100 text-blue-700 border-blue-200";
    case "Cardio":
      return "bg-red-100 text-red-700 border-red-200";
    case "Strength":
      return "bg-purple-100 text-purple-700 border-purple-200";
    case "Mind & Body":
      return "bg-green-100 text-green-700 border-green-200";
    case "Dance":
      return "bg-orange-100 text-orange-700 border-orange-200";
    default:
      return "bg-gray-100 text-gray-700 border-gray-200";
  }
};
